import {
    ENCODE_REQUEST,
    ENCODE_SUCCESS,
    ENCODE_FAIL,
    RESET_GENERATED_PCR,
    ENCODE_RESET,
    APPLY_TEMPLATE_REQUEST,
    APPLY_TEMPLATE_SUCCESS,
    APPLY_TEMPLATE_FAIL,
    RESET_APPLY_TEMPLATE,
    CONCISE_REPORT_REQUEST,
    CONCISE_REPORT_SUCCESS,
    CONCISE_REPORT_FAIL,
    RESET_CONCISE_REPORT,
    REPORT_FEEDBACK_REQUEST,
    REPORT_FEEDBACK_SUCCESS,
    REPORT_FEEDBACK_FAIL,
    RESET_REPORT_FEEDBACK,
    GENERATE_REPORT_REQUEST,
    GENERATE_REPORT_SUCCESS,
    GENERATE_REPORT_FAIL,
    GENERATE_LAB_REQUEST,
    GENERATE_LAB_SUCCESS,
    GENERATE_LAB_FAIL,
    ADD_SAMPLE_PCR,
} from '../constants/encodeConstants'

const sampleNarrative = `
Dispatched to private residence for 65 y/o male c/o chest pain and dizziness.
Upon arrival, patient found sitting upright on couch, alert and oriented x3.
Patient reports onset of substernal chest pressure approximately 45 minutes prior, radiating to left arm.
Denies shortness of breath, nausea, or recent trauma.
Vitals: BP 148/92, HR 88, RR 18, SpO2 97% on room air.
Lung sounds clear bilaterally, no JVD, no pedal edema noted.
12-lead EKG obtained, showing ST depression in lateral leads.
Aspirin 324 mg administered PO per protocol, IV established in left AC with NS TKO.
Patient transported emergent to local cardiac center with continuous monitoring en route.
Condition remained stable during transport; report given to ED staff without incident.
`

export const getEncodeReducer = (state = { }, action) => {
    switch(action.type) {
        case ENCODE_REQUEST:
            return {loading:true, encodeError: null }

        case ENCODE_SUCCESS:
            return {loading:false, encodeError: null, text: action.payload }

        case ENCODE_FAIL:
            return {loading:false, encodeError: action.payload }

        case ENCODE_RESET:
            return { loading: false, encodeError: null, text: ''}

        case ADD_SAMPLE_PCR:
            return { chartLoading: false, text: sampleNarrative }
    
        default:
            return state
    }
}

export const getReportReducer = (state = { }, action) => {
    switch(action.type) {
        case GENERATE_REPORT_REQUEST:
            return { chartLoading: true, chartText: null, chartError: null }

        case GENERATE_REPORT_SUCCESS:
            return { chartLoading: false, chartText: action.payload, chartError: null }

        case GENERATE_REPORT_FAIL:
            return { chartLoading: false, chartError: action.payload }

        case RESET_GENERATED_PCR:
            return { chartLoading: false, chartText: null }

        default:
            return state
    }
}

export const getApplyTemplateReducer = (state = { }, action) => {
    switch(action.type) {
        case APPLY_TEMPLATE_REQUEST:
            return { applyingTemplate:true, templateText: null, templateError: null }

        case APPLY_TEMPLATE_SUCCESS:
            return { applyingTemplate:false, templateText: action.payload, templateError: null }

        case APPLY_TEMPLATE_FAIL:
            return { applyingTemplate:false, templateError: action.payload }

        case RESET_APPLY_TEMPLATE:
            return { applyingTemplate: false, templateText: null, templateError: null }

        default:
            return state
    }
}

export const getConciseReportReducer = (state = { }, action) => {
    switch(action.type) {
        case CONCISE_REPORT_REQUEST:
            return { concisingText: true, conciseError: null }

        case CONCISE_REPORT_SUCCESS:
            return { concisingText: false, conciseText: action.payload, conciseError: null }

        case CONCISE_REPORT_FAIL:
            return { concisingText: false, conciseError: action.payload }

        case RESET_CONCISE_REPORT:
            return { concisingText: false, conciseText: null, conciseError: null }

        default:
            return state
    }
}

export const getReportFeedbackReducer = (state = { }, action) => {
    switch(action.type) {
        case REPORT_FEEDBACK_REQUEST:
            return { feedbackInprogress: true, feedbackText: null, conciseError: null }

        case REPORT_FEEDBACK_SUCCESS:
            return { feedbackInprogress: false, feedbackText: action.payload, conciseError: null }

        case REPORT_FEEDBACK_FAIL:
            return { feedbackInprogress: false, feedbackError: action.payload }

        case RESET_REPORT_FEEDBACK:
            return { feedbackInprogress: false, feedbackText: null, feedbackError: null }

        default:
            return state
    }
}

export const getReclassifyReducer = (state = { }, action) => {
    switch(action.type) {
        default:
            return state
    }
}

export const getLabReducer = (state = { }, action) => {
    switch(action.type) {
        case GENERATE_LAB_REQUEST:
            return { labInProgress: true }

        case GENERATE_LAB_SUCCESS:
            return { labInProgress: false, labText: action.payload }

        case GENERATE_LAB_FAIL:
            return { labInProgress: false, labText: action.payload }

        default:
            return state
    }
}